// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"datadisplaytable_wrapper__3zW2Y","tableWrapper":"datadisplaytable_tableWrapper__148pr","pagination":"datadisplaytable_pagination__q91C3"};